<template>
    <div class="operationSelect" id='operationSelect' ref='operationSelect'>
      <lk-select
        v-model="operCategoryCodes"
        clearable
        :multiple="!multiple"
        remote
        filterable
        :placeholder='placeholder'
        @on-query-change='handleQuery'
        @on-change='handleChange'
        :remote-method="search"
        :loading="false">
        <lk-option v-for="item in filtedList" :key="item.operCategoryCode" :value='item.operCategoryCode' :disabled='item.disabled'>{{item.operCategoryName}}</lk-option>
      </lk-select>
      <lk-icon v-if="this.operCategoryCodes.length" class='icon'  type="ios-close-circle" @click="clear"/>
    </div>
</template>
<script>
import service from '../services/system';
import utils from '../libs/utils';

export default {
  name: 'operationListSelect',
  props: {
    value: {
      type: Array | String,
    },
    multiple: {
      type: Boolean,
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
  },
  model: {
    prop: 'value',
    event: 'on-change',
  },
  data() {
    return {
      menuList: [],
      operCategoryCodes: [],
      filtedList: [],
      isHover: false,
    };
  },
  watch: {
    value(val = []) {
      this.operCategoryCodes = val;
    },
  },
  computed: {
    canClear() {
      return (this.isHover && !!this.operCategoryCodes.length);
    },
    menuListLength() {
      return this.menuList.length;
    },
  },
  methods: {
    clear() {
      this.operCategoryCodes = [];
      this.$emit('on-change', []);
    },
    handleQuery(val) {
      if (!val) {
        this.filtedList = this.menuList;
      }
    },
    search(query) {
      if (query !== '') {
        this.filtedList = this.menuList.filter(item => item.operCategoryName.indexOf(query) > -1);
      } else {
        this.filtedList = this.menuList;
      }
    },
    handleChange(val) {
      if (Array.isArray(val) && val.length >= 20) {
        this.$set(this, 'operCategoryCodes', this.value);
        this.filtedList.forEach((opt) => {
          if (!val.includes(opt.operCategoryCode)) {
            opt.disabled = true;
          }
        });
        this.$Message.error('选择最多支持20个');
        return;
      }
      this.filtedList.forEach((opt) => {
        opt.disabled = false;
      });
      this.$emit('on-change', val);
    },
    getMenuList() {
      service.getMenuList().then((res) => {
        if (res.data.status === 200) {
          this.menuList = res.data.data;
          this.filtedList = this.menuList;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.getMenuList();
  },
};
</script>
<style scoped lang="less">
    #operationSelect{
        display: flex;
        align-items: center;
        .icon{
            margin-left:-20px;
            z-index:100;
            font-size: 14px;
            color: #808695;
            display: none
        }
    }
    #operationSelect:hover{
        .icon{
            cursor: pointer;
            display: block
    }
}
</style>